import { LuImageOff, LuImageUp } from "react-icons/lu";

export default function ImageDropArea({
  className,
  isValidFileType = true,
}: {
  className?: string;
  isValidFileType?: boolean;
}) {
  return (
    <div
      className={`absolute inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center ${className}`}
      onDragOver={(e) => e.preventDefault()}
    >
      <div className="p-8 flex flex-col items-center gap-4 max-w-md mx-4">
        {isValidFileType ? <LuImageUp size={48} /> : <LuImageOff size={48} />}
        <div className="text-center">
          <p className="text-xl font-semibold mb-2">
            {isValidFileType ? "Add a file" : "Invalid file type"}
          </p>
          <p>
            {isValidFileType ? (
              <>
                Drop any file here to add it
                <br />
                to your prompt
              </>
            ) : (
              <>
                Accepted file formats: JPEG,
                <br />
                PNG, WebP
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}
